import {
  Newfooter,
  Prodemo,
  Section0,
  Section1,
  Section2,
  Section3,
  Section4,
  Section5,
  Section6,
} from "./components";
import MainLayout from "../../layouts/MainLayOut";

function Home() {
  return (
    <MainLayout>
      <div className="w-screen text-base text-black ">
        <div
          style={{
            background:
              "radial-gradient(at 53% 63%, #edf7fa 0px, transparent 50%), " +
              "radial-gradient(at 24% 69%,rgb(255, 255, 255) 0px, transparent 50%), " +
              "radial-gradient(at 48% 53%,rgba(241, 119, 255, 0.74) 0px, transparent 50%), " +
              "radial-gradient(at 57% 1%,rgba(225, 133, 230, 0.33) 0px, transparent 50%), " +
              "radial-gradient(at 49% 28%,rgb(255, 216, 250) 0px, transparent 50%), " +
              "#ffffff",
          }}
          className="sm:pt-10 sm:mx-auto w-full  max-w-screen-xl">
          <Section0 />
        </div>
        <div className="px-4 sm:px-10 md:px-20 sm:mx-auto w-full  max-w-screen-xl">
          <Section2 />
        </div>
        <div className="sm:mx-auto w-full  max-w-screen-xl px-4 sm:px-10 md:px-20">
          <Section1 />
        </div>

        <div className="bg-black w-full sm:flex sm:justify-center sm:items-center px-4 sm:px-10 md:px-20 ">
          <Prodemo />
        </div>
        <div className="sm:mx-auto w-full  max-w-screen-xl  px-4 sm:px-10 md:px-20">
          <Section3 />
        </div>
        <div className="sm:mx-auto w-full  max-w-screen-xl px-4 sm:px-10 md:px-20">
          <Section6 />
        </div>
        <div className="sm:mx-auto w-full  max-w-screen-xl px-4 sm:px-10 md:px-20">
          <Section4 />
        </div>

        <Section5 />
        <div className="w-full sm:mx-auto sm:px-10 bg-gradient-to-t from-white to-blue-50 h-10 sm:h-36"></div>
        <Newfooter />
      </div>
    </MainLayout>
  );
}

export default Home;
